var _rect, _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 503,
    viewBox: "0 0 572 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 109.999,
    width: 352,
    height: 288,
    rx: 34,
    stroke: "#2C2C2C",
    strokeWidth: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M534.124 351.46L440.624 307.549C435.36 305.077 432 299.786 432 293.972V210.812C432 204.851 435.529 199.456 440.991 197.068L534.491 156.185C544.401 151.852 555.5 159.113 555.5 169.929V337.883C555.5 348.873 544.071 356.132 534.124 351.46Z",
    stroke: "#2C2C2C",
    strokeWidth: 32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 491.661,
    x2: 491.661,
    y2: 7.99999,
    stroke: "#FF3B30",
    strokeWidth: 16,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCameraIcon);
export default __webpack_public_path__ + "static/media/disabled-camera-icon.ddd2e43b88abf9f9cf90dec29e70d0be.svg";
export { ForwardRef as ReactComponent };